import { Config } from 'config/envConfig';
import React, { forwardRef } from 'react';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { LandingPageButton } from '@quyva/shared-ui';
import { useNavigate } from 'react-router';

const CTASection = forwardRef((props, ref) => {
    const navigate = useNavigate();

    const handleClick = (url) => {
        if (url) {
            navigate(url);
        } else {
            window.location.href = '/';
        }
    };

    return (
        <div ref={ref}>
            <section className='py-24 bg-gradient-to-br from-landing-slate-900 to-landing-slate-800 relative overflow-hidden'>
                <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
                <div className='max-w-4xl mx-auto px-6 relative z-10 text-center'>
                    <h2 className='text-3xl md:text-4xl font-bold text-landing-white mb-6'>
                        Ready to Transform Your Data Experience?
                    </h2>
                    <p className='text-xl text-landing-slate-300 mb-10 max-w-2xl mx-auto'>
                        Join enterprises already using Quyva to unlock insights
                        from their documents and databases with natural
                        language.
                    </p>
                    <div className='flex justify-center'>
                        <LandingPageButton
                            onClick={() => handleClick('/contactUs')}
                            className='px-8 py-4 bg-landing-blue-500 text-landing-white rounded-lg font-bold hover:bg-landing-blue-600 transition shadow-lg shadow-landing-blue-600/20 inline-flex items-center justify-center gap-2'
                            text='Contact Us'
                            icon={faEnvelope}
                        />
                    </div>
                </div>
            </section>
        </div>
    );
});

export default CTASection;
